import { render, staticRenderFns } from "./skillCard.vue?vue&type=template&id=fde9222c"
import script from "./skillCard.vue?vue&type=script&lang=js"
export * from "./skillCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports